import React from 'react';
import useTranslation from '../../../Hooks/useTranslation';
import styles from './AddressSuggestionsDropdown.module.scss';

interface AddressSuggestionsDropdownProps {
	isLoading: boolean;
	suggestions: Record<string, unknown>[];
	onSelect: (item: Record<string, unknown>) => void;
	formatItem?: (item: Record<string, unknown>) => string;
}

const defaultFormatItem = (item: Record<string, unknown>) =>
	String(item.fullAddress ?? item.label ?? item.displayName) ||
	JSON.stringify(item);

export default function AddressSuggestionsDropdown({
	isLoading,
	suggestions,
	onSelect,
	formatItem = defaultFormatItem,
}: AddressSuggestionsDropdownProps) {
	const { t } = useTranslation();

	if (isLoading) {
		return (
			<div className={styles.status}>{t('base.addressWhisperer.loading')}</div>
		);
	}

	if (suggestions.length === 0) {
		return (
			<div className={styles.status}>
				{t('base.addressWhisperer.noResults')}
			</div>
		);
	}

	return (
		<ul className={styles.list}>
			{suggestions.map((item, index) => (
				<li
					key={index}
					className={styles.item}
					onClick={() => onSelect(item)}
					role='button'
					tabIndex={0}
					onKeyDown={e => e.key === 'Enter' && onSelect(item)}>
					{formatItem(item)}
				</li>
			))}
		</ul>
	);
}
